import React from "react"
import { Box } from "@chakra-ui/react"
import { useForm } from "react-hook-form"
import { DioboxEvent, TextMessage } from "sharedTypes"
import FormContent from "../FormContent/FormContent"

// Bypasses ContainedForm: opt-in is a setting, not a form-with-submit.
type Props = {
  event: DioboxEvent
  selectedTextMessage: TextMessage
  onSave: (textMessage: TextMessage, options?: { silent?: boolean }) => void
  showSavedLabel: boolean
}

const OptInTextBody = ({
  event, selectedTextMessage, onSave, showSavedLabel,
}: Props) => {
  const { control, watch, getValues } = useForm({
    values: { ...selectedTextMessage, type: "sms" } as any,
  })

  return (
    <Box borderRadius="xl" borderWidth={1} bgColor="white" px={6} py={4}>
      <FormContent
        control={control}
        event={event}
        selectedTextMessage={selectedTextMessage}
        handleSave={onSave}
        watch={watch}
        getValues={getValues}
        showSavedLabel={showSavedLabel}
      />
    </Box>
  )
}

export default OptInTextBody
